import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class ClientValidateOTPUseCase extends BaseUseCase {
    constructor(loginFLowRepo) {
        super();
        this.loginFLowRepo = loginFLowRepo;
    }
    fetchResult(data) {
        return this.loginFLowRepo.clientValidateOTP(data);
    }
}
export default ClientValidateOTPUseCase;
